import { createContext } from 'react';
import type { useMIPCreateController } from '@dealstack/frontend/app/pages/Project/MIP/MIPCreate/useMIPCreateController';

export const MIPCreateContext = createContext<ReturnType<typeof useMIPCreateController>>(
	{} as ReturnType<typeof useMIPCreateController>
);
